import React from "react";
import cns from "classnames";

import { ThemeType } from "@theme";
import WithTooltip from "./WithTooltip";
import { makeStyles } from "@material-ui/core/styles";

export type ButtonOptions = {
  key: string;
  disabled?: boolean;
  icon: React.ReactElement<any>;
  onClick?: (e: React.SyntheticEvent<any>) => any;
  title?: string;
  titleDisabled?: string;
};

export type FloatingMenuProps = {
  className?: string;
  buttons: ButtonOptions[];
};

/**
 * slack-style menu
 */
export function FloatingMenu({ buttons, className }: FloatingMenuProps) {
  const classes = useStyles({});
  return (
    <div className={cns(className, classes.root)}>
      {buttons.map((btn) => (
        <div
          className={cns(classes.icon, { [classes.disabled]: btn.disabled })}
          onClick={btn.onClick}
          key={btn.key}
          data-test={`FloatingMenu_${btn.key}`}
        >
          <WithTooltip
            title={btn.disabled ? btn.titleDisabled || btn.title : btn.title}
            placement="top"
          >
            {btn.icon}
          </WithTooltip>
        </div>
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    alignItems: "stretch",
    backgroundColor: theme.palette.background.default,
    borderColor: theme.separatorColor,
    borderRadius: theme.spacing(1 / 2),
    borderStyle: "solid",
    borderWidth: 1,
    height: 28,
    display: "inline-flex",
    overflow: "hidden",
    transform: "translateY(-20%)",
    opacity: 0,

    transition: "opacity 100ms ease-in-out, box-shadow 200ms ease-in-out",

    "&:hover": {
      borderColor: theme.palette.grey[500],
      boxShadow: "0px 0px 2px rgba(0,0,0,0.3)"
    }
  },

  icon: {
    display: "flex",
    alignItems: "center",
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderColor: theme.separatorColor,
    color: theme.palette.grey[700],
    paddingRight: theme.spacing(),
    paddingLeft: theme.spacing(),
    fontSize: 20,

    "&:last-child": {
      border: "none"
    },

    "&:not($disabled):hover": {
      // backgroundColor: darken(0.01, theme.palette.background.default),
      color: theme.palette.secondary.main,

      cursor: "pointer"
    }
  },

  disabled: {
    color: theme.palette.grey[300]
  }
}));
